module.exports = __webpack_public_path__ + "assets/img/face_search_scene1.9145c8c7.png";